import React from 'react'
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'

const COLORS = [
  '#2DC9C8',
  '#48C2C7',
  '#A1E3E4',
  '#E6FAFB',
  '#C3EFF1'
]

const RADIAN = Math.PI / 180

const renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, percent, index, name }) => {
  const radius = outerRadius + 10
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill="#143145"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={12}
    >
      {name}
    </text>
  )
}

const DonutChart = ({ data, valueKey = 'value', nameKey = 'name', colors = COLORS }) => {
  return (
    <div className="w-full h-52">
      <ResponsiveContainer>
        <PieChart>
          <Tooltip
            formatter={(value) => `R$${value.toLocaleString('pt-BR')}`}
          />
          <Pie
            data={data}
            dataKey={valueKey}
            nameKey={nameKey}
            innerRadius="60%"
            outerRadius="80%"
            label={renderCustomizedLabel}
            stroke="none"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default DonutChart
